import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiServiceService } from './api-service.service';

export type AgenciesOnboardItem = {
  mdaId: string;
  mdaName: string;
  totalVendors: number;
};

export type LandingPageStats = {
  pendingVendorsApproval: number;
  totalVendors: number;
  totalVendorsRegisteredLast30Days: number;
  percentageRegisteredLast30Days?: number;
  totalPaymentAmountProcessed: number;
  totalVendorsApprovedAllTime: number;
  totalVendorsApprovedLast30Days: number;
  percentageApprovedLast30Days?: number;
  agenciesOnboard: AgenciesOnboardItem[];
};

type LandingPageStatsResponse = {
  status: string;
  message?: string;
  data?: {
    success?: boolean;
    data?: LandingPageStats;
    meta?: unknown;
    error?: unknown;
  };
};

@Injectable({ providedIn: 'root' })
export class LandingPageStatsService {
  constructor(private readonly api: ApiServiceService) {}

  getLandingPageStats(): Observable<LandingPageStats> {
    return this.api.get('/landing-page/stats').pipe(
      map((res: LandingPageStatsResponse) => {
        const payload = res?.data?.data;
        if (!payload) {
          throw new Error('Landing page stats payload is missing.');
        }
        return payload;
      }),
    );
  }
}
